import { Inject } from '@angular/core';
import '@angular/compiler';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { ComponentChatComponent } from './component.chat/component.chat.component';
import { ComponentJoystickComponent } from './component.joystick/component.joystick.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { ComponentSidemenuComponent } from './component.sidemenu/component.sidemenu.component';
import { ComponentToastComponent } from './component.toast/component.toast.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { ComponentMinimapComponent } from './component.minimap/component.minimap.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { ComponentContextmenuComponent } from './component.contextmenu/component.contextmenu.component';
import { ComponentNoteComponent } from './component.note/component.note.component';
import { ComponentModalComponent } from './component.modal/component.modal.component';
import { ComponentCenterswitcherComponent } from './component.centerswitcher/component.centerswitcher.component';
import { PageLoginComponent } from './page.login/page.login.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { ComponentCharacterComponent } from './component.character/component.character.component';
import { LayoutSidebarComponent } from './layout.sidebar/layout.sidebar.component';
import { PageMainComponent } from './page.main/page.main.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { ComponentOnlinepanelComponent } from './component.onlinepanel/component.onlinepanel.component';
import { PageCenterRoomComponent } from './page.center.room/page.center.room.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, COMPOSITION_BUFFER_MODE } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NuMonacoEditorModule } from '@ng-util/monaco-editor';
import { SortablejsModule } from "src/libs/portal/season/ngx-sortablejs";
import { KeyboardShortcutsModule } from 'ng-keyboard-shortcuts';
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'safe' })
export class SafePipe implements PipeTransform {
    constructor(@Inject( DomSanitizer) private domSanitizer: DomSanitizer) { }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }
}

// translate libs
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'
import { HttpClient, HttpClientModule } from '@angular/common/http';

export function createTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http, './assets/lang/', '.json');
}

// initialize ng module
@NgModule({
    declarations: [
        SafePipe,
        AppComponent,
        PortalSeasonLoadingSeasonComponent,
        ComponentChatComponent,
        ComponentJoystickComponent,
        PortalSeasonFormDropdownComponent,
        ComponentSidemenuComponent,
        ComponentToastComponent,
        PortalSeasonModalComponent,
        PortalPostListComponent,
        ComponentMinimapComponent,
        PortalPostDetailComponent,
        PortalSeasonTreeComponent,
        ComponentContextmenuComponent,
        ComponentNoteComponent,
        ComponentModalComponent,
        ComponentCenterswitcherComponent,
        PageLoginComponent,
        LayoutEmptyComponent,
        ComponentCharacterComponent,
        LayoutSidebarComponent,
        PageMainComponent,
        PortalSeasonPaginationComponent,
        ComponentOnlinepanelComponent,
        PageCenterRoomComponent,
        PortalSeasonLoadingDefaultComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        NgbModule,
        SortablejsModule,
        KeyboardShortcutsModule.forRoot(),
        NuMonacoEditorModule.forRoot({ baseUrl: `lib` }),
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            },
            defaultLanguage: 'en'
        }),
        
    ],
    providers: [
        {
            provide: COMPOSITION_BUFFER_MODE,
            useValue: false
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }